<div class="mb-4 flex flex-col">
  <app-filter-operator
    [operator]="rawOperatorCommand()"
    [operators]="appFilterOperators()"
    [notOperators]="appFilterNotOperators()"
    (operatorChange)="setOperator($event)"
  ></app-filter-operator>
  <div
    class="flex mb-2 gap-2 max-h-6 border-b border-solid border-gray-300 has-[:focus]:border-primary-400 pb-1"
  >
    <mat-icon inline class="inline-flex align-middle">search</mat-icon>
    <input
      [formControl]="searchControl"
      type="text"
      class="focus:outline-none min-w-52 flex-grow"
    />
  </div>
  <div class="border-b border-solid border-gray-300 py-2 text-sm">
    <div>
      <label
        class="inline-flex gap-2 items-center"
        (click)="$event.preventDefault(); selectAll()"
      >
        <input type="checkbox" class="h-[8px] border-0" />
        <span i18n class="cursor-pointer">Select all</span>
      </label>
    </div>
    <div>
      <label
        class="inline-flex gap-2 items-center"
        (click)="$event.preventDefault(); deselectAll()"
      >
        <input type="checkbox" class="h-[8px] border-0" />
        <span i18n class="cursor-pointer">Deselect all</span>
      </label>
    </div>
  </div>
  <div
    class="max-h-[200px] overflow-auto"
    #scroller
    (scroll)="onScroll(scroller)"
  >
    @for (item of searchItems(); track item.id) {
      <div class="text-sm">
        <label class="inline-flex gap-2 items-center cursor-pointer">
          <input
            type="checkbox"
            class="h-[8px] border-0"
            [checked]="isItemChecked | apply: selectedItems() : item"
            (change)="toggleItem(item)"
          />
          {{ item.label }}
        </label>
      </div>
    }
    <div
      class="hidden text-center mt-4 text-sm text-gray-400"
      i18n
      [class.!block]="loading()"
    >
      - Loading -
    </div>
  </div>
</div>
